import React from "react";
import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const Instructor = ({ svgProps, pathProps }: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };

  return (
    <svg {...mergedSvgProps}>
      <path
        d="M11.25 16.25C14.0114 16.25 16.25 14.0114 16.25 11.25C16.25 8.48858 14.0114 6.25 11.25 6.25C8.48858 6.25 6.25 8.48858 6.25 11.25C6.25 14.0114 8.48858 16.25 11.25 16.25Z"
        {...mergedPathProps}
      />
      <path
        d="M11.25 18.75C7.9125 18.75 1.25 20.425 1.25 23.75V26.25H21.25V23.75C21.25 20.425 14.5875 18.75 11.25 18.75ZM20.95 6.7L18.85 8.8125C19.9 10.2875 19.9 12.2 18.85 13.675L20.95 15.7875C23.475 13.2625 23.475 9.45 20.95 6.7ZM25.0875 2.5L23.05 4.5375C26.5125 8.3125 26.5125 13.9875 23.05 17.9625L25.0875 20C29.9625 15.1375 29.975 7.5625 25.0875 2.5Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default Instructor;
